import { Turbo } from '@hotwired/turbo-rails';

Turbo.session.drive = false;

import '../application/rails_confirm';
import '../application/client_side_validations';
import '../application/whitelist_confirm';
import '../application/analytics';

import 'controllers';

document.addEventListener('DOMContentLoaded', function () {
  import('application/notyf');
});

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};
